import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

function Breadcrumb({ items }) {
    return (
        <nav aria-label="breadcrumb" className="mb-4">
            <ol className="flex items-center space-x-2 text-sm text-muted-foreground">
                {items.map((item, index) => (
                    <li key={index} className="flex items-center space-x-2">
                        {index > 0 && <ChevronRight className="h-4 w-4" />}
                        {item.to ? (
                            <Link to={item.to} className="hover:text-primary transition-colors">
                                {item.label}
                            </Link>
                        ) : (
                            <span className="font-medium text-foreground" aria-current="page">
                                {item.label}
                            </span>
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    );
}

export default Breadcrumb;